import { PAGE_SIZE_OPTIONS } from './helpers';

const WINDOW = 2; // pages shown each side of current

function getPageNumbers(page, totalPages) {
  const pages = [];
  const start = Math.max(1, page - WINDOW);
  const end = Math.min(totalPages, page + WINDOW);

  if (start > 1) {
    pages.push(1);
    if (start > 2) pages.push('...');
  }
  for (let i = start; i <= end; i++) pages.push(i);
  if (end < totalPages) {
    if (end < totalPages - 1) pages.push('...');
    pages.push(totalPages);
  }
  return pages;
}

const btnBase =
  'min-w-[32px] h-[32px] px-2 rounded-lg border text-[12px] font-medium transition-colors';
const btnIdle = `${btnBase} border-[#D7DEE8] text-[#475569] hover:bg-[#F1F5F9]`;
const btnActive = `${btnBase} border-[#334155] bg-[#334155] text-white`;
const btnDisabled = `${btnBase} border-[#D7DEE8] text-[#475569] opacity-40 cursor-not-allowed`;

const Pagination = ({ page, totalPages, pageSize, onPageSizeChange, onPrev, onNext, onGoToPage }) => {
  const pageNums = getPageNumbers(page, totalPages);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 mt-4">
      {/* Rows per page */}
      <div className="flex items-center gap-2">
        <label className="text-[12px] text-[#97A3B5]">Rows per page:</label>
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          className="border border-[#D7DEE8] rounded-lg px-2 py-1 text-[12px] text-[#353E4A] bg-white focus:outline-none focus:ring-2 focus:ring-[#334155]/20"
        >
          {PAGE_SIZE_OPTIONS.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>

      {/* Page numbers + prev/next */}
      <div className="flex items-center gap-1">
        <button
          onClick={onPrev}
          disabled={page <= 1}
          className={page <= 1 ? btnDisabled : btnIdle}
        >
          ←
        </button>

        {pageNums.map((p, i) =>
          p === '...' ? (
            <span key={`ellipsis-${i}`} className="px-1 text-[12px] text-[#97A3B5] select-none">…</span>
          ) : (
            <button
              key={p}
              onClick={() => p !== page && onGoToPage(p)}
              className={p === page ? btnActive : btnIdle}
            >
              {p}
            </button>
          )
        )}

        <button
          onClick={onNext}
          disabled={page >= totalPages}
          className={page >= totalPages ? btnDisabled : btnIdle}
        >
          →
        </button>
      </div>
    </div>
  );
};

export default Pagination;
